import React from 'react';
import { 
  Route, 
  // BrowserRouter, 
  // HashRouter as Router,
  Switch, HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { Provider } from 'react-redux';
import LoginScene from 'bundles/LoginRegister/scenes/LoginScene';
import LogoutScene from 'bundles/LoginRegister/scenes/LogoutScene';
import RegisterScene from 'bundles/LoginRegister/scenes/RegisterScene';
import DashboardScene from 'bundles/Dashboard/scenes/DashboardScene';
import AboutScene from 'bundles/About/scenes/AboutScene';
import AccountScene from 'bundles/Account/scenes/AccountScene'
import NotFound from 'shared/components/NotFound';

export default function (store, theme) {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <HashRouter basename="/" >
                    {/* <Router basename="/~gtamhan3"> */}
                    <Switch>
                        <Route exact path="/" component={DashboardScene} />
                        <Route exact path="/about" component={AboutScene} />
                        <Route exact path="/user/login" component={LoginScene} />
                        <Route exact path="/user/register" component={RegisterScene} />
                        <Route exact path="/user/account" component={AccountScene} />
                        <Route exact path="/user/logout" component={LogoutScene} />
                        <Route component={NotFound} />
                    </Switch>
                </HashRouter>
            </ThemeProvider>
        </Provider>
    )
}